import { render, staticRenderFns } from "./LocumUnAvailabilities.vue?vue&type=template&id=0ffae152&"
import script from "./LocumUnAvailabilities.vue?vue&type=script&lang=js&"
export * from "./LocumUnAvailabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports